export default __webpack_public_path__ + "static/char-s-33-zh-Hant-d8c6557cbb1cdee9e06e11cdfbf67fc0.webp";